import React from 'react';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router';
import Button from '../ui/form/Button';
import Page, { PageTitle } from '../ui/Page';
import List from '../project/List';
import Create from '../project/Create';
import Project from '../project/Project';

export default function Engines() {
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();

  return (
    <Page title={'Projects'}>
      <PageTitle>
        {location.pathname === '/projects' && (
          <Button
            label="New Project +"
            onClick={() => {
              history.push('/projects/create');
            }}
          />
        )}
      </PageTitle>
      <Switch>
        <Route path={`${match.path}/create`}>
          <Create />
        </Route>
        <Route path={`${match.path}/:projectid`}>
          <Project />
        </Route>
        <Route path={match.path}>
          <List />
        </Route>
      </Switch>
    </Page>
  );
}
